const badgeKeys = {
  badgeInfo:() => ['digitalBadgeInfo'],
};

export default badgeKeys;